import { Transporte } from "../../components";

export const CategoriaTransporte = () => <Transporte />;
